/* CsvSerializer.js */

"use strict";

const papaparse = require("papaparse");

const ARRAY_SEPARATOR = "; ";

const FORMULA_PREFIX = /^[=+\-@|%\t\r＝＋－＠]/;

function escapeCsvFormula(value) {
    return FORMULA_PREFIX.test(value) ? "'" + value : value;
}

function normalizeCell(value) {
    if (Array.isArray(value)) {
        return value.map(normalizeCell).join(ARRAY_SEPARATOR);
    }
    if (value === null || value === undefined) {
        return "";
    }
    return String(value);
}

function convertToCSV(convertData) {
    const rows = Array.isArray(convertData) ? convertData : [convertData];
    const firstRow = rows.find((row) => row);
    if (!firstRow) {
        return "";
    }
    const keys = Object.keys(firstRow);
    const toCell = (value) => escapeCsvFormula(normalizeCell(value));
    const fields = keys.map(toCell);
    const data = rows.map((row) => keys.map((key) => toCell(row ? row[key] : "")));
    return papaparse.unparse({fields, data});
}

module.exports = {
    ARRAY_SEPARATOR,
    convertToCSV,
    escapeCsvFormula,
    normalizeCell,
};
